import React, { useCallback, useRef } from "react";

import { Button } from "@app/scripts/react-general-components/Button";

import type { AuthStates } from "@app/scripts/types";

type Props = {
  content: any;
  switchForm: React.Dispatch<React.SetStateAction<AuthStates>>;
};

export const AccountRecoverForm: React.FC<Props> = ({ content, switchForm }) => {
  const ref = useRef(null);

  const onSubmit = useCallback(() => {
    window.Shopify.recaptchaV3.addToken(ref?.current, "recover_customer_password");
    return false;
  }, [ref?.current]);

  return (
    <div className="login__drawer-forgot">
      <ui-form>
        <form onSubmit={onSubmit} ref={ref} method="post" action="/account/recover" accept-charset="UTF-8">
          <input type="hidden" name="redirect" value="/account/login#recover" />

          <input type="hidden" name="form_type" value="recover_customer_password"></input>

          <div className="_field">
            <input
              type="email"
              name="email"
              className="_field__input"
              id="ResetEmail_drawer"
              autoComplete="email"
              autoCapitalize="off"
              required
              placeholder={content?.recover_password?.email}
            />
            <label htmlFor="ResetEmail_drawer" className="_field__label">
              {content?.recover_password?.email}
            </label>
          </div>

          <p className="text-sm text-brand-dark-grey">{content.recover_password.subtext}</p>

          <div className="login-recover__submit">
            <Button
              label={content?.recover_password?.submit}
              variant="secondary"
              type="submit"
              className="login__reset-btn fullwidth"
            />
            <Button
              onClick={() => switchForm("login")}
              label={content?.recover_password?.cancel}
              variant="text"
              className="login__reset-btn fullwidth"
            />
          </div>
        </form>
      </ui-form>
    </div>
  );
};
